import { notification } from "antd";
import { useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import { SchemaFormAuditType } from "../../../../components/forms/FormAuditType";
import {
  useCreateAuditTypeMutation,
  useDeleteAuditTypeMutation,
  useUpdateAuditTypeMutation,
} from "../../apiSlice";
import { getErrorMessage } from "../../../../utils/errors/errors";

type FetchAuditTypes = () => void;

export const useCrudAuditType = (
  auditTypeId: number,
  fetchAuditTypes: FetchAuditTypes,
  onHideModal: () => void,
) => {
  const [lazyCreateAuditType, { isLoading: isCreating }] =
    useCreateAuditTypeMutation();
  const [lazyUpdateAuditType, { isLoading: isUpdating }] =
    useUpdateAuditTypeMutation();
  const [lazyDeleteAuditType, { isLoading: isDeleting }] =
    useDeleteAuditTypeMutation();

  const createAuditType: SubmitHandler<SchemaFormAuditType> = useCallback(
    async (values) => {
      try {
        await lazyCreateAuditType(values).unwrap();
        notification.success({ message: "Type d'audit crÃ©Ã© avec succÃ¨s." });
        onHideModal();
        fetchAuditTypes();
      } catch (e) {
        notification.error({ message: "Erreur", description: getErrorMessage(e) });
      }
    },
    [lazyCreateAuditType, fetchAuditTypes, onHideModal],
  );

  const updateAuditType: SubmitHandler<SchemaFormAuditType> = useCallback(
    async (values) => {
      try {
        await lazyUpdateAuditType({ auditTypeId, values }).unwrap();
        notification.success({ message: "Type d'audit modifiÃ© avec succÃ¨s." });
        onHideModal();
        fetchAuditTypes();
      } catch (e) {
        notification.error({ message: "Erreur", description: getErrorMessage(e) });
      }
    },
    [auditTypeId, lazyUpdateAuditType, fetchAuditTypes, onHideModal],
  );

  const onDelete = useCallback(
    async (id: number) => {
      try {
        await lazyDeleteAuditType(id).unwrap();
        notification.success({ message: "Type d'audit supprimÃ© avec succÃ¨s." });
        fetchAuditTypes();
      } catch (e) {
        notification.error({ message: "Erreur", description: getErrorMessage(e) });
      }
    },
    [lazyDeleteAuditType, fetchAuditTypes],
  );

  return {
    createAuditType,
    isCreating,
    updateAuditType,
    isUpdating,
    onDelete,
    isDeleting,
  };
};
